/**
 * 组织管理相关常量
 */

// 模态框类型
export const MODAL_TYPES = {
    CREATE: 'create',
    EDIT: 'edit'
};

// 操作类型
export const ACTION_TYPES = {
    CREATE_CHILD: 'create_child',
    EDIT: 'edit',
    MOVE: 'move',
    DELETE: 'delete'
};

// 默认分页配置
export const DEFAULT_PAGINATION = {
    current: 1,
    pageSize: 100
};

// 用户加载限制
export const USER_LOAD_LIMIT = 200;
